import {
    collection,
    doc,
    addDoc,
    getDoc,
    getDocs,
    updateDoc,
    deleteDoc
} from "firebase/firestore";
import { trackerDb } from "../config";

export const getAllArchetypes = async () => {
    try {
        const archetypesRef = collection(trackerDb, "archetype");
        const querySnapshot = await getDocs(archetypesRef);

        const archetypes = querySnapshot.docs.map(archetypeDoc => ({
            id: archetypeDoc.id,
            ...archetypeDoc.data()
        }));

        return archetypes;
    } catch (error) {
        console.error("Błąd podczas pobierania archetypów:", error);
        throw error;
    }
};

export const getArchetypePopularity = async () => {
    try {
        const docRef = doc(trackerDb, "stats", "archetypeOpponentCounts");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data().counts) {
            return docSnap.data().counts;
        }
        return null;
    } catch (error) {
        console.warn("Brak globalnej popularności archetypów:", error?.message);
        return null;
    }
};

export const getArchetype = async (archetypeId) => {
    try {
        const archetypeRef = doc(trackerDb, "archetype", archetypeId);
        const archetypeDoc = await getDoc(archetypeRef);

        if (archetypeDoc.exists()) {
            return { id: archetypeDoc.id, ...archetypeDoc.data() };
        } else {
            return null;
        }
    } catch (error) {
        console.error("Błąd podczas pobierania archetypu:", error);
        throw error;
    }
};

export const createArchetype = async (archetypeData) => {
    try {
        const archetypesRef = collection(trackerDb, "archetype");
        const archetypeWithTimestamp = {
            ...archetypeData,
            createdAt: new Date().toISOString(),
            modifiedAt: new Date().toISOString()
        };
        const createdDocRef = await addDoc(archetypesRef, archetypeWithTimestamp);
        return createdDocRef.id;
    } catch (error) {
        console.error("Błąd podczas tworzenia archetypu:", error);
        throw error;
    }
};

export const updateArchetype = async (archetypeId, archetypeData) => {
    try {
        const archetypeRef = doc(trackerDb, "archetype", archetypeId);
        const archetypeWithTimestamp = {
            ...archetypeData,
            modifiedAt: new Date().toISOString()
        };
        await updateDoc(archetypeRef, archetypeWithTimestamp);
        return archetypeId;
    } catch (error) {
        console.error("Błąd podczas aktualizacji archetypu:", error);
        throw error;
    }
};

export const deleteArchetype = async (archetypeId) => {
    try {
        const archetypeRef = doc(trackerDb, "archetype", archetypeId);
        await deleteDoc(archetypeRef);
        return true;
    } catch (error) {
        console.error("Błąd podczas usuwania archetypu:", error);
        throw error;
    }
};
